(() => {
  if (customElements.get('product-family-picker')) return;
  class ProductFamilyPicker extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.choices = JSON.parse(this.querySelector('[data-family-choices]').textContent);
      this.labels = JSON.parse(this.querySelector('[data-family-labels]').textContent);
      if (!this.choices.length) return;
      this.section = this.closest('.product-section');
      this.colors = [...new Set(this.choices.map(choice => choice.color))];
      this.sizes = [...new Set(this.choices.map(choice => choice.size))];
      const requested = new URL(location.href).searchParams.get('family_size');
      this.size = this.sizes.includes(requested) ? requested : this.dataset.size;
      this.color = this.dataset.color;
      this.render();
      this.section?.querySelectorAll('[data-family-native-options]').forEach(native => { native.hidden = true; });
      this.setAttribute('data-ready', '');
      this.lockPurchase();
      this.observer = new MutationObserver(() => this.lockPurchase());
      this.section?.querySelectorAll('[data-add-to-cart], .shopify-payment-button').forEach(element => {
        this.observer.observe(element, { attributes: true, attributeFilter: ['disabled', 'hidden'] });
      });
      this.onSubmit = event => {
        if (!this.blocked || !event.target.matches('form[action*="/cart/add"]')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.querySelector('[role="status"]').focus();
      };
      this.section?.addEventListener('submit', this.onSubmit, true);
    }
    text(key, values = {}) {
      return (this.labels[key] || '').replace(/\[\[(\w+)\]\]/g, (_, name) => String(values[name] ?? ''));
    }
    matching(color, size) {
      const exact = this.choices.filter(choice => choice.color === color && choice.size === size);
      return exact.find(choice => choice.available) || exact[0];
    }
    availableSizes(color) {
      return this.sizes.filter(size => this.choices.some(choice => choice.color === color && choice.size === size && choice.available));
    }
    href(choice, size) {
      const target = new URL(choice.url, location.origin);
      target.searchParams.set('family_size', size);
      return target.pathname + target.search;
    }
    render() {
      const selected = this.matching(this.color, this.size);
      this.blocked = !selected?.available;
      this.querySelector('[data-family-color]').textContent = this.color;
      this.querySelector('[data-family-size]').textContent = this.size;
      const colorGroup = this.querySelector('[data-family-colors]');
      colorGroup.replaceChildren();
      for (const color of this.colors) {
        const choices = this.choices.filter(choice => choice.color === color);
        const matching = this.matching(color, this.size);
        const choice = matching || choices.find(choice => choice.available) || choices[0];
        const link = document.createElement('a');
        link.className = 'family-picker__color';
        if (!matching?.available) link.classList.add('is-unavailable');
        link.href = this.href(choice, this.size);
        const label = matching?.available ? color : this.text(matching ? 'unavailable' : 'not_offered', { color, size: this.size });
        link.setAttribute('aria-label', label);
        if (color === this.color) link.setAttribute('aria-current', 'true');
        link.title = label;
        if (choice.image) {
        link.classList.add('family-picker__color--photo');

        const image = document.createElement('img');
        image.src = choice.image;
        image.alt = '';
        image.width = 56;
        image.height = 64;
        image.loading = 'lazy';
        image.decoding = 'async';
        link.append(image);
        } else {
        link.classList.add('family-picker__color--text');
        link.textContent = color;
        }
        colorGroup.append(link);
      }
      const sizeGroup = this.querySelector('[data-family-sizes]');
      sizeGroup.replaceChildren();
      for (const size of this.sizes) {
        const matching = this.matching(this.color, size);
        const choice = matching?.available ? matching : this.choices.find(choice => choice.size === size && choice.available) || matching;
        const link = document.createElement('a');
        link.className = 'family-picker__size';
        link.textContent = size;
        if (!matching?.available) link.classList.add('is-unavailable');
        if (size === this.size) link.setAttribute('aria-current', 'true');
        link.href = choice ? this.href(choice, size) : '#'+this.id;
        const label = matching?.available ? size : this.text(matching ? 'unavailable' : 'not_offered', { color: this.color, size });
        link.setAttribute('aria-label', label);
        link.title = label;
        if (!choice) {
          link.addEventListener('click', event => {
            event.preventDefault();
            this.size = size;
            this.render();
            this.lockPurchase();
          });
        }
        sizeGroup.append(link);
      }
      const status = this.querySelector('[role="status"]');
      status.classList.toggle('is-unavailable', this.blocked);
      status.hidden = !this.blocked;
      this.querySelector('[data-family-status]').textContent = this.blocked ? this.text(selected ? 'unavailable' : 'not_offered', { color: this.color, size: this.size }) : '';
    }
    lockPurchase() {
      if (!this.section) return;
      this.section.querySelectorAll('[data-add-to-cart]').forEach(button => {
        if (this.blocked) {
          if (!button.disabled) button.disabled = true;
          button.dataset.familyBlocked = 'true';
        } else if (button.dataset.familyBlocked) {
          button.disabled = false;
          delete button.dataset.familyBlocked;
        }
      });
      this.section.querySelectorAll('.shopify-payment-button').forEach(button => {
        if (this.blocked) {
          if (!button.hidden) button.hidden = true;
          button.dataset.familyBlocked = 'true';
        } else if (button.dataset.familyBlocked) {
          button.hidden = false;
          delete button.dataset.familyBlocked;
        }
      });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.section?.removeEventListener('submit', this.onSubmit, true);
    }
  }
  customElements.define('product-family-picker', ProductFamilyPicker);
})();

